"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.supportSettingsLoader = void 0;
const pino_1 = __importDefault(require("pino"));
const access_1 = require("../../../../common/constants/access");
const appConstants_1 = require("../../../constants/appConstants");
const companyQuery_1 = require("../../../queries/companyQuery");
const requestProfilesQuery_1 = require("../../../queries/requestProfilesQuery");
const supportQuery_1 = require("../../../queries/supportQuery");
const userQuery_1 = require("../../../queries/userQuery");
const userSelectors_1 = require("../../../selectors/userSelectors");
const supportSettingsLoader = async ({ queryClient, params, }) => {
    const logger = (0, pino_1.default)();
    const verifyUserAccessQuery = (0, userQuery_1.getVerifyUserAccessQuery)(access_1.composites.WRITE_COMPANY);
    const profilesQuery = (0, requestProfilesQuery_1.getProfilesQuery)();
    const serverVersionQuery = (0, supportQuery_1.getServerVerionQuery)();
    const providerMappingQuery = (0, supportQuery_1.getProviderMappingQuery)();
    const workflowConfigsQuery = (0, supportQuery_1.getWorkflowConfigsQuery)();
    const providerMappingConfigsQuery = (0, supportQuery_1.getProviderMappingConfigsQuery)();
    const userData = await queryClient.ensureQueryData(userQuery_1.userQuery);
    const userRole = (0, userSelectors_1.isCompanyOrSupportAdmin)(userData.roles)
        ? appConstants_1.overviewConstants.COMPANY_ADMIN
        : userData.roles.find(role => role.securityGroupId === params.teamId)?.roleId || '';
    const companyProperties = await queryClient.ensureQueryData((0, companyQuery_1.companyPropertiesQuery)(userData.companyAccountId, { showactivity: appConstants_1.companyPropertiesConstants.showactivity }));
    const workflowConfigQuery = (0, supportQuery_1.getWorkflowConfigQuery)({ companyId: userData.companyAccountId });
    const serverVersion = await queryClient.ensureQueryData({
        queryKey: serverVersionQuery.queryKey,
        queryFn: serverVersionQuery.queryFn,
    });
    const config = await queryClient.ensureQueryData({
        queryKey: workflowConfigQuery.queryKey,
        queryFn: workflowConfigQuery.queryFn,
    });
    const workflowConfigs = await queryClient.ensureQueryData({
        queryKey: workflowConfigsQuery.queryKey,
        queryFn: workflowConfigsQuery.queryFn,
    });
    const hasAccess = await queryClient.ensureQueryData({
        queryKey: verifyUserAccessQuery.queryKey,
        queryFn: verifyUserAccessQuery.queryFn,
    });
    let companyFeatures;
    try {
        companyFeatures = await queryClient.ensureQueryData(companyQuery_1.companyFeaturesQuery);
    }
    catch (error) {
        logger.error(error);
    }
    const profiles = await queryClient.ensureQueryData({
        queryKey: profilesQuery.queryKey,
        queryFn: profilesQuery.queryFn,
    });
    const requestProfiles = await queryClient.ensureQueryData((0, requestProfilesQuery_1.requestProfilesQuery)(userData.companyAccountId, false));
    const providerMappingConfigs = await queryClient.ensureQueryData({
        queryKey: providerMappingConfigsQuery.queryKey,
        queryFn: providerMappingConfigsQuery.queryFn,
    });
    const providerMap = await queryClient.ensureQueryData(providerMappingQuery);
    return {
        userRole,
        userData,
        hasAccess,
        profiles,
        providerMap,
        companyFeatures,
        serverVersion,
        workflowConfigs,
        requestProfiles,
        configId: config.id,
        providerMappingConfigs,
        companyProperties,
    };
};
exports.supportSettingsLoader = supportSettingsLoader;
